import React from "react";

export const ShowHide: React.FC<{ show: boolean, children: any }> = props => {

    return <div style={{ display: props.show ? 'inherit' : 'none' }}>{props.children}</div>;

}